import { ScreenSize } from '@/styles/legacyComponentLibraryTheme';
import { makeStyles } from '@/styles/theme/tss-react';

const useStyles = makeStyles({ name: 'MuiImageGridFourCirclesText' })(
  ({ brandColors, breakpoints, type, typography }) => ({
    container: {
      height: typography.pxToRem(670),
      display: 'flex',
      flexDirection: 'row-reverse',
      justifyContent: 'center',
      paddingLeft: typography.pxToRem(60),
      paddingRight: typography.pxToRem(150),
      [breakpoints.down(ScreenSize.MEDIUM)]: {
        width: '100%',
        height: typography.pxToRem(720),
        flexDirection: 'column',
        paddingLeft: 0,
        paddingRight: 0,
        justifyContent: 'flex-start',
      },
    },
    textContainer: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      textWrap: 'pretty',
      maxWidth: typography.pxToRem(800),
      marginLeft: typography.pxToRem(140),
      [breakpoints.down(ScreenSize.MEDIUM)]: {
        paddingTop: typography.pxToRem(50),
        paddingLeft: typography.pxToRem(26),
        paddingRight: typography.pxToRem(58),
        marginRight: 0,
        marginLeft: 0,
        marginBottom: typography.pxToRem(41),
      },
    },
    title: {
      ...type['88_medium'],
      color: brandColors.primaryMain,
      margin: 0,
      [breakpoints.down(ScreenSize.MEDIUM)]: {
        ...type['44_medium'],
      },
    },
    circleImageContainer: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
    },
    circleImageRow: {
      display: 'flex',
      marginBottom: 20,
      marginTop: 20,
    },
  })
);

export default useStyles;
